import Page from "components/Page";
import { ShopListProps } from "./ShopList.types";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const ShopList = lazyWithRetry(() => import("./ShopList"));

export default (props: ShopListProps) => (
  <Page>
    <ShopList {...props} />
  </Page>
);
